/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import { useLocation } from 'js/lib/useRouter';

import { NotFound } from 'bundles/common/components/withNotFound';
import DegreesCategorySchemaMarkup from 'bundles/premium-hub/components/seo/DegreesCategorySchemaMarkup';
import PremiumHubPageHeader from 'bundles/premium-hub/components/shared/PremiumHubPageHeader';
import { HubPages } from 'bundles/premium-hub/constants';
import usePremiumHubPageData from 'bundles/premium-hub/hooks/usePremiumHubPageData';
import OverviewPageContent from 'bundles/premium-hub/pages/subpages/OverviewPageContent';
import { convertPpcPremiumProductToPremiumProductProps } from 'bundles/premium-hub/utils/dataTransformationUtils';

import _t from 'i18n!nls/premium-hub';

const LandingPageContent = () => {
  const pageType = HubPages.LandingPage;
  const location = useLocation();
  const premiumHubPageData = usePremiumHubPageData(pageType);

  if (!premiumHubPageData) {
    return null;
  }

  const { categoryData, premiumProductList, pageContent, loading, useSimplifiedHeader = false } = premiumHubPageData;

  if (!loading && !pageContent) {
    // If pageContent doesn't exist, a page for this route hasn't been configured in Contentful
    return <NotFound />;
  }

  return (
    <>
      <PremiumHubPageHeader isSimplified={useSimplifiedHeader} location={location} />
      <main id="main">
        <DegreesCategorySchemaMarkup
          allDegreeLists={[
            {
              degreeType: _t('Degrees'),
              title: categoryData?.name ?? '',
              degrees: premiumProductList?.map(convertPpcPremiumProductToPremiumProductProps) ?? [],
            },
          ]}
          currentHubPage={pageType}
        />
        <OverviewPageContent {...premiumHubPageData} currentPageType={pageType} shouldShowDriftChat={false} />
      </main>
    </>
  );
};

export default compose<{}, React.PropsWithChildren<{}>>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'program_hub',
      page: 'degree_sub',
    },
  }))
)(LandingPageContent);
